import config from '@plone/volto/registry';

/**
 * XXX: Essa função veio da Api do Volto. Para não precisar customizar o arquivo.
 * Duplicamos o código aqui.
 * Format the url.
 * @function formatUrl
 * @param {string} path Path (or URL) to be formatted.
 * @returns {string} Formatted path.
 */
export function formatUrl(path) {
  const { settings } = config;
  const APISUFIX = settings.legacyTraverse ? '' : '/++api++';
  const prefix = settings.prefixPath;

  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  let apiPath = '';
  if (settings.internalApiPath && __SERVER__) {
    apiPath = settings.internalApiPath;
  } else if (settings.apiPath) {
    apiPath = settings.apiPath;
  }

  let adjustedPath = path[0] !== '/' ? `/${path}` : path;
  if (prefix && adjustedPath.match(new RegExp(`^${prefix}(/|$)`))) {
    adjustedPath = adjustedPath.slice(prefix.length);
    adjustedPath = adjustedPath[0] !== '/' ? `/${adjustedPath}` : adjustedPath;
  }

  return `${apiPath}${APISUFIX}${adjustedPath}`;
}
